module.exports = __webpack_public_path__ + "static/media/bs.910d4bd0.svg";